import { withViewData } from "../App/ViewData"
import { CruiseViewUI } from "./Cruise/CruiseViewUI"
import { CruiseDataView } from "./Cruise/DataView"
import type { CruiseDataProps, CruiseViewProps } from "./Cruise/Params"

export { CruiseViewData } from "./Cruise/Context"
export type { CruiseViewProps } from "./Cruise/Params"

const CruiseDataViewWithUI = withViewData<CruiseDataProps>({
  acquire: CruiseDataView,
  ui: CruiseViewUI,
});

export function CruiseView({ children, ...props }: CruiseViewProps) {
  return <CruiseDataViewWithUI {...props} cruiseChildren={children} />;
}
